export type JurisdictionCode = 'USA' | 'AUSTRIA' | 'CYPRUS';

export interface JurisdictionOption {
  code: JurisdictionCode;
  label: string;
}

export const SUPPORTED_JURISDICTIONS: JurisdictionOption[] = [
  // { code: 'USA', label: 'United States' },
  { code: 'AUSTRIA', label: 'Austria' },
  { code: 'CYPRUS', label: 'Cyprus' },
];

export const DEFAULT_JURISDICTION: JurisdictionCode = 'AUSTRIA';

